import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'

import { formatApiDate } from '../../../../utils/helpers/date'
import { generalClient, serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { validateFieldValues } from '../../../../utils/helpers/fields'
import { generateClient } from '../../../../utils/apollo/_config/generateClient'

const MUTATION = gql`
  mutation InsertEvents($inputs: [EventInput]) {
    insertEvents(inputs: $inputs) {
      id
    }
  }
`

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.status?.id, { path: ['status'], message: 'Campo obrigatório' }),
    ...appendIf(!form.reason?.id, { path: ['reason'], message: 'Campo obrigatório' }),
    ...validateFieldValues(form)
  ]

  setErrors(errors)
  return errors.length === 0
}

const cleanRequest = item =>
  item.serviceOrderIds.map(serviceOrderId => ({
    statusId: item.status?.id,
    eventDate: formatApiDate(new Date()),
    reasonId: item.reason?.id,
    description: item.description,
    serviceOrderId
  }))

export const useInsertEvents = onSuccess => {
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['ServiceOrders', 'ServiceOrder', 'ServiceOrdersCount'],
    client: serviceOrdersClient,
    onCompleted: () => {
      generalClient.refetchQueries({ include: ['CalendarEvents'] })
    }
  })

  const handleRequest = async (form, actions) => {
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      const inputs = cleanRequest(form)
      return request({ variables: { inputs } }).then(resp => {
        if (!resp.errors) {
          closeModal()
          onSuccess && onSuccess()
        }
      })
    }
  }

  return [handleRequest, state]
}
